import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Datajamxha8esaab as Data } from '../SavePartyMutation.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.n6h_1 = listOf('saveParty');
      }
      o3z(reader, customScalarAdapters) {
        var _saveParty = null;
        $l$loop: while (true) {
          if (reader.g4c(this.n6h_1) === 0)
            _saveParty = get_NullableBooleanAdapter().o3z(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_saveParty);
      }
      o6h(writer, customScalarAdapters, value) {
        writer.r47('saveParty');
        get_NullableBooleanAdapter().t3z(writer, customScalarAdapters, value.s6f_1);
      }
      p3z(writer, customScalarAdapters, value) {
        return this.o6h(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance2pj4711kc59sc,
};
//endregion

//# sourceMappingURL=SavePartyMutation_ResponseAdapter.mjs.map
